import ColleagueReaderNode from './types/colleague-reader';
import ColleagueWriterNode from './types/colleague-writer';

export const colleagueNodes = {
  colleagueWriter: ColleagueWriterNode,
  colleagueReader: ColleagueReaderNode,
};
